import { message, Form } from 'antd'
import { useEffect, useReducer } from 'react'
import { history } from '../../redux/store'
import {
  GET_SUPPLINER_ORDER_DETAIL,
  GET_SUPPLINER_ORDER_SHIP,
  GET_SUPPLINER_ORDER_RETURN,
  GET_SUPPLINER_ORDER_CANCEL,
  CONFIRM_ORDER,
  CHANGE_EXPRESSCOMPANY,
  CONFIRM_GOODS,
  ORDER_STORY,
  EXPORT_ALL_DETAIL,
  GET_SUPPLIER_COUNT,
  GET_LOGISTICS_INFORMATION,
  LogisticsInformation,
  GET_OMS_EXPRESSCOMPANY_LIST,
  REFUSE_SUPPLIER_ORDER,
  EXPORT_ORDER_SHIP_DETAIL,
  EXPORT_SELECT_ORDER_DETAIL,
} from '../../api/orderManage'
import { COMPLETE_TODO } from '../../api/CommonApi'
import {
  isResponseCodeSuccess,
  getItemFromItemListByProperty,
  getUserId,
} from '../../tools/util'
import { WaterMarkOption } from '../../components/previewModal'
import { useQuery } from '../../tools/utilHooks'
import reducer, {
  initialState,
  setCheckedRadioKeyAction,
  setIsTableLoadingAction,
  setDeliveryListAction,
  setReturnDetailListAction,
  setCancelDetailListAction,
  setSelectedRowsAction,
  setCurrentRadioDictAction,
  setLoadingAction,
  setDetailInfoAction,
  setProductListAction,
  setProgressValueAction,
  setIsChangeDeliveryInfoModalVisibleAction,
  setExpressSelectListAction,
  setSubmitBtnLoadingAction,
  setExpressSearchValueAction,
  ProgressTimeKey,
  setProgressTimeAction,
  setLogisticsInfoListAction,
  setIsPreviewModalVisibleAction,
  setPreviewFileUrlAction,
  setWaterMarkOptionAction,
  setRejectModalOpenAction,
  setRejectLoadingAction,
  setRejectReasonAction,
  setShowTipAction,
  setExpressIdAction,
  setDownLoadModalAciton,
  setDownLoadSelectedRowKeysAction,
  setCustomerOrderCodeListAction,
} from './reducer'
import { MAX_SUPPLIER_DELIVERY_COUNT } from '../../global/config'

export type orderdetailTabKey =
  | '商品明细'
  | '发货明细'
  | '退货明细'
  | '取消明细'

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    detailInfo,
    selectedRows,
    submitBtnLoading,
    expressSelectList,
    expressId,
    progressTime,
    logisticsInfoList,
    rejectReason,
    downLoadSelectedRowKeys,
    customerOrderCodeList,
    productList,
  } = state
  const query = useQuery()
  const id = query.get('id') || ''
  const tab = query.get('tab') || ''
  const contractId = query.get('contractId') || ''
  const [formModal] = Form.useForm()
  /**
   * 表格多选选择框选中事件
   * @param key
   */
  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKeyAction(key))
    getDetailList(key)
  }
  /**
   * 发货、退货、取消明细
   * @param key 明细
   */

  const getDetailList = async (key: string) => {
    if (key === '发货明细') {
      dispatch(setIsTableLoadingAction(true))
      const res = await GET_SUPPLINER_ORDER_SHIP({ id: id })
      if (isResponseCodeSuccess(res.code)) {
        dispatch(setIsTableLoadingAction(false))
        dispatch(setDeliveryListAction(res.data))
        getOrderLogisticsInfo(res.data)
      }
    } else if (key === '退货明细') {
      dispatch(setIsTableLoadingAction(true))
      const res = await GET_SUPPLINER_ORDER_RETURN({ id: id })
      if (isResponseCodeSuccess(res.code)) {
        dispatch(setIsTableLoadingAction(false))
        dispatch(setReturnDetailListAction(res.data))
      }
    } else if (key === '取消明细') {
      dispatch(setIsTableLoadingAction(true))
      const res = await GET_SUPPLINER_ORDER_CANCEL({ id: id })
      if (isResponseCodeSuccess(res.code)) {
        dispatch(setIsTableLoadingAction(false))
        dispatch(setCancelDetailListAction(res.data))
      }
    }
  }

  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  const handleDownLoadTableCheck = (selectedRowKeys: any) => {
    dispatch(setDownLoadSelectedRowKeysAction(selectedRowKeys))
  }
  /**
   * 判断发货进度
   * @param record
   * @returns
   */
  const judgeDeliveryProgress = (converted: any) => {
    if (converted.waitQty > 0) return '待发货' // 未发货（待发数量>0）
    if (converted.waitQty === 0) return '已完成' // 全部发货（待发数量=0）
  }
  const getOrderCount = async () => {
    const res = await GET_SUPPLIER_COUNT({
      supplierOrderId: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(
        setCurrentRadioDictAction({
          商品明细: {
            key: 'productDetail',
            value: '商品明细',
            keyName: '商品明细',
          },
          发货明细: {
            key: 'deliveryDetail',
            value: `发货明细(${res?.data?.invoiceCount ?? 0})`,
            // value: `发货明细`,
            keyName: '发货明细',
          },
          退货明细: {
            key: 'returnDetail',
            value: `退货明细(${res?.data?.returnOrderCount ?? 0})`,
            // value: `退货明细`,
            keyName: '退货明细',
          },
          取消明细: {
            key: 'cancelDetail',
            value: `取消明细(${res?.data.cancellationOrderCount ?? 0})`,
            // value: `取消明细`,
            keyName: '取消明细',
          },
        }),
      )
    }
  }
  const getDetailInfo = async () => {
    dispatch(setLoadingAction(true))
    const res = await GET_SUPPLINER_ORDER_DETAIL({
      id: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 将嵌套的 directedSignVoucher 扁平化为页面可用字段
      const directedSignVoucher = (resData as any).directedSignVoucher
      const detailData = {
        ...resData,
        signVoucherState:
          directedSignVoucher?.signVoucherState ?? resData.signVoucherState,
        signVoucherRejectReason:
          directedSignVoucher?.signVoucherRejectReason ??
          resData.signVoucherRejectReason,
        signVoucherTime:
          directedSignVoucher?.signVoucherTime ?? resData.signVoucherTime,
        signVoucherFiles:
          directedSignVoucher?.signVoucherFiles ?? resData.signVoucherFiles ?? [],
      }
      dispatch(setDetailInfoAction(detailData))
      const detailedProductDTOList: any = resData.detailedProductDTOList.map(
        (item: any) => ({
          ...item,
          progress: judgeDeliveryProgress({
            ...item,
          }),
        }),
      )
      const customerOrderCodeList = resData.customerOrderCode
        ?.split(',')
        .map((code) => ({ customerOrderCode: code.trim() }))
      dispatch(setCustomerOrderCodeListAction(customerOrderCodeList))
      dispatch(setProductListAction(detailedProductDTOList))
      setTimeout(() => {
        getOrderCount()
      }, 200)
    } else {
      message.warning(res.msg)
    }
    dispatch(setLoadingAction(false))
  }
  // 订单状态如果不是待履约或履约中不能发货
  const handleDeliveryClick = async () => {
    const res = await GET_SUPPLINER_ORDER_DETAIL({
      id: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      if (res.data.orderState === '5' || res.data.orderState === '7') {
        message.error('订单处于修改审核中，请联系相关采购处理')
        return
      }
    }

    if (detailInfo?.scpShipStatusName === '已完成') {
      message.error('订单已完成,无需发货')
      return
    }

    const scpShipStatus = detailInfo.scpShipStatus
    if (selectedRows.length < 1) {
      message.error('请先选中货物')
      return
    }
    if (selectedRows.length > MAX_SUPPLIER_DELIVERY_COUNT) {
      message.warning(
        `您好，您只能勾选${MAX_SUPPLIER_DELIVERY_COUNT}行物料进行操作`,
      )
      return
    }
    if (
      selectedRows.some((item) => item.warehouse !== selectedRows[0].warehouse)
    ) {
      message.error('请选择同一批收货仓库的物料进行发货')
      return
    }
    if (scpShipStatus === 'WAIT') {
      history.push({
        pathname: '/srm/addsupplierdeliveryorder',
        state: {
          ...detailInfo,
          selectedProductList: selectedRows,
        },
      })
    }
  }

  // 商品明细导出发货单
  const exportSelectOrderDetail = async () => {
    if (selectedRows.length < 1 && customerOrderCodeList.length <= 1) {
      message.error('请先选中货物')
      return
    }
    if (customerOrderCodeList.length > 1 && detailInfo.directShipment) {
      dispatch(setDownLoadModalAciton(true))
    } else {
      exportNote(false)
    }
  }

  // 导出配货单
  const exportNote = async (isMultiple: boolean) => {
    const unshipped = isMultiple
      ? productList.filter(
          (item: { waitQty: number; shipQty: number }) =>
            (item.waitQty > 0 && item.shipQty === 0) ||
            (item.waitQty > 0 && item.shipQty > 0),
        )
      : selectedRows
    const params = {
      directShipment: detailInfo.directShipment,
      orderId: id,
      customerOrderCodes: isMultiple
        ? downLoadSelectedRowKeys.join(',')
        : detailInfo.customerOrderCode,
      productCodeList: unshipped.map((item) => item.productCode),
      ids: unshipped.map((item) => item.id),
    }
    // 调用导出函数
    await EXPORT_SELECT_ORDER_DETAIL(params)
  }

  // 商品明细-根据进度筛选
  const onProgressChange = (value: any) => {
    dispatch(setProgressValueAction(value))
    const filterRes = value
      ? detailInfo?.productList.filter((item: any) => item.progress === value)
      : detailInfo?.productList
    dispatch(setProductListAction(filterRes))
  }

  useEffect(() => {
    if (id) {
      getDetailInfo()
      getOrderStory()
    }
    getExpressSelectData()
    // 在订单详情页面时，点击消息中心跳转，订单id发生变化重新获取数据
    // eslint-disable-next-line
  }, [id])

  // 待办跳转时自动切换到取消明细tab
  useEffect(() => {
    if (tab === 'cancel') {
      handleCheckedChange('取消明细')
    }
    // eslint-disable-next-line
  }, [tab])

  useEffect(() => {
    if (contractId) {
      completeToDo(contractId)
    }
    // eslint-disable-next-line
  }, [contractId])
  const completeToDo = async (todoId: string) => {
    await COMPLETE_TODO({ todoId })
  }
  // 确认订单
  const confirmOrder = async () => {
    const res = await CONFIRM_ORDER({ id: detailInfo.id })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      getDetailInfo()
      getOrderStory()
    }
  }
  //
  const changeExpress = (item: any) => {
    if (
      item.logisticsCode.split(',').length > 1 ||
      item.trackNum.split(',').length > 1
    ) {
      message.warning('存在多个物流信息，不支持修改')
      return
    }
    formModal.setFieldsValue({
      expressCompany: item.logisticsCode,
      expressNo: item.trackNum,
    })
    dispatch(setExpressIdAction(item.id))
    dispatch(setIsChangeDeliveryInfoModalVisibleAction(true))
  }

  async function getExpressSelectData() {
    const res = await GET_OMS_EXPRESSCOMPANY_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setExpressSelectListAction(res.data))
    } else {
      message.warning('物流公司列表请求失败')
    }
  }
  const handleDeliveryInfoSave = async () => {
    const formValues = await formModal.validateFields()
    dispatch(setSubmitBtnLoadingAction(true))
    const expressName = getItemFromItemListByProperty(
      expressSelectList,
      'expressCode',
      formValues.expressCompany,
    )?.expressCompany
    const data = {
      id: expressId,
      logisticsCompany: expressName,
      logisticsCode: formValues.expressCompany,
      trackNum: formValues.expressNo,
    }
    const res = await CHANGE_EXPRESSCOMPANY({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      handleChangeDeliveryInfoCancel()
      getDetailList('发货明细')
      dispatch(setSubmitBtnLoadingAction(false))
    }
  }

  const handleChangeDeliveryInfoCancel = () => {
    dispatch(setIsChangeDeliveryInfoModalVisibleAction(false))
  }

  const onExpressSearch = (val: string) => {
    dispatch(setExpressSearchValueAction(val))
  }

  const onExpressSelect = () => {
    dispatch(setExpressSearchValueAction(''))
  }

  const confirmGoods = async (id: string) => {
    const res = await CONFIRM_GOODS({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      getDetailList('退货明细')
    }
  }

  const getOrderStory = async () => {
    const res = await ORDER_STORY({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      const resData: {
        [x in ProgressTimeKey]: number | null
      } = {
        ...res.data,
        completeStockTime: res.data.completeOrderTime,
      }
      const newProgressTime = progressTime.map((item) => ({
        ...item,
        time: resData[item.timeKey],
      }))
      dispatch(setProgressTimeAction(newProgressTime))
    }
  }
  const exportOrder = async () => {
    const res = await EXPORT_ALL_DETAIL({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }
  // 导出配货单直接下载到本地
  const exportSendOrder = async (orderid: string) => {
    EXPORT_ORDER_SHIP_DETAIL({ shippingOrderId: orderid })
  }
  const getCurrentProgress = () => {
    // <订单完成>步骤,有完成时间或订单状态为'已完成',就默认走到最后一步
    const done = progressTime.find((item) => {
      return item.timeKey === 'completeOrderTime'
    })
    if (done?.time || detailInfo?.scpShipStatusName === '已完成') {
      return 5
    } else {
      return progressTime.filter((item) => item.time).length
    }
  }

  // 获取物流轨迹信息
  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  const showPreviewModal = (url: string, watermarkOption?: WaterMarkOption) => {
    dispatch(setPreviewFileUrlAction(url))
    dispatch(setWaterMarkOptionAction(watermarkOption))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  const getOrderLogisticsInfo = async (data: any) => {
    // 获取当前所有发货单对应的物流信息
    const res: LogisticsInformation[][] = await Promise.all(
      data.map(async (item: any) => {
        if (item.trackNum) {
          const res = await GET_LOGISTICS_INFORMATION({
            expressCode: item.logisticsCode,
            expressNo: item.trackNum,
            id: item.id,
            phoneNumber: detailInfo.receiveMobile,
          })
          if (isResponseCodeSuccess(res.code)) {
            return res.data
          } else {
            return []
          }
        }
      }),
    )
    dispatch(setLogisticsInfoListAction(res))
  }

  // 拒绝接单按钮
  const rejectOrder = () => {
    dispatch(setRejectModalOpenAction(true))
  }

  // 确认拒绝接单
  const handleRejectOk = async () => {
    if (rejectReason !== '') {
      dispatch(setRejectLoadingAction(true))
      const res = await REFUSE_SUPPLIER_ORDER({
        orderId: id,
        refuseReason: rejectReason,
        refuseOperatorId: getUserId(),
      })
      if (isResponseCodeSuccess(res.code)) {
        dispatch(setRejectReasonAction(''))
        dispatch(setRejectModalOpenAction(false))
        dispatch(setRejectLoadingAction(false))
        getDetailInfo()
        getOrderStory()
      } else {
        dispatch(setRejectLoadingAction(false))
      }
    } else {
      dispatch(setShowTipAction(true))
    }
  }

  // 取消拒绝接单
  const handleRejectCancel = () => {
    dispatch(setShowTipAction(false))
    dispatch(setRejectReasonAction(''))
    dispatch(setRejectModalOpenAction(false))
  }

  // 修改拒绝接单理由
  const changeRejectReason = (val: string) => {
    dispatch(setShowTipAction(false))
    dispatch(setRejectReasonAction(val))
  }

  // 关闭导出弹窗
  const downLoadModalCancel = () => {
    dispatch(setDownLoadModalAciton(false))
  }

  const downLoadModalOk = () => {
    if (!downLoadSelectedRowKeys.length) {
      message.warning('请先选择订单号')
      return
    } else if (downLoadSelectedRowKeys.length >= 200) {
      message.warning('每次最多选择200条客户订单导出')
      return
    }
    exportNote(true)
    dispatch(setDownLoadModalAciton(false))
  }
  return {
    hooksState: state,
    handleCheckedChange,
    handleDeliveryClick,
    handleTableChangeCheck,
    onProgressChange,
    confirmOrder,
    changeExpress,
    submitBtnLoading,
    handleDeliveryInfoSave,
    handleChangeDeliveryInfoCancel,
    formModal,
    onExpressSearch,
    onExpressSelect,
    confirmGoods,
    exportOrder,
    exportSendOrder,
    getCurrentProgress,
    getDetailInfo,
    exportSelectOrderDetail,
    logisticsInfoList,
    showPreviewModal,
    cancelPreviewModal,
    rejectOrder,
    handleRejectOk,
    handleRejectCancel,
    changeRejectReason,
    downLoadModalCancel,
    downLoadModalOk,
    handleDownLoadTableCheck,
  }
}
import { message, Form } from 'antd'
import { useEffect, useReducer } from 'react'
import { history } from '../../redux/store'
import {
  GET_SUPPLINER_ORDER_DETAIL,
  GET_SUPPLINER_ORDER_SHIP,
  GET_SUPPLINER_ORDER_RETURN,
  GET_SUPPLINER_ORDER_CANCEL,
  CONFIRM_ORDER,
  CHANGE_EXPRESSCOMPANY,
  CONFIRM_GOODS,
  ORDER_STORY,
  EXPORT_ALL_DETAIL,
  GET_SUPPLIER_COUNT,
  GET_LOGISTICS_INFORMATION,
  LogisticsInformation,
  GET_OMS_EXPRESSCOMPANY_LIST,
  REFUSE_SUPPLIER_ORDER,
  EXPORT_ORDER_SHIP_DETAIL,
  EXPORT_SELECT_ORDER_DETAIL,
} from '../../api/orderManage'
import { COMPLETE_TODO } from '../../api/CommonApi'
import {
  isResponseCodeSuccess,
  getItemFromItemListByProperty,
  getUserId,
} from '../../tools/util'
import { WaterMarkOption } from '../../components/previewModal'
import { useQuery } from '../../tools/utilHooks'
import reducer, {
  initialState,
  setCheckedRadioKeyAction,
  setIsTableLoadingAction,
  setDeliveryListAction,
  setReturnDetailListAction,
  setCancelDetailListAction,
  setSelectedRowsAction,
  setCurrentRadioDictAction,
  setLoadingAction,
  setDetailInfoAction,
  setProductListAction,
  setProgressValueAction,
  setIsChangeDeliveryInfoModalVisibleAction,
  setExpressSelectListAction,
  setSubmitBtnLoadingAction,
  setExpressSearchValueAction,
  ProgressTimeKey,
  setProgressTimeAction,
  setLogisticsInfoListAction,
  setIsPreviewModalVisibleAction,
  setPreviewFileUrlAction,
  setWaterMarkOptionAction,
  setRejectModalOpenAction,
  setRejectLoadingAction,
  setRejectReasonAction,
  setShowTipAction,
  setExpressIdAction,
  setDownLoadModalAciton,
  setDownLoadSelectedRowKeysAction,
  setCustomerOrderCodeListAction,
} from './reducer'
import { MAX_SUPPLIER_DELIVERY_COUNT } from '../../global/config'

export type orderdetailTabKey =
  | '商品明细'
  | '发货明细'
  | '退货明细'
  | '取消明细'

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    detailInfo,
    selectedRows,
    submitBtnLoading,
    expressSelectList,
    expressId,
    progressTime,
    logisticsInfoList,
    rejectReason,
    downLoadSelectedRowKeys,
    customerOrderCodeList,
    productList,
  } = state
  const query = useQuery()
  const id = query.get('id') || ''
  const tab = query.get('tab') || ''
  const contractId = query.get('contractId') || ''
  const [formModal] = Form.useForm()
  /**
   * 表格多选选择框选中事件
   * @param key
   */
  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKeyAction(key))
    getDetailList(key)
  }
  /**
   * 发货、退货、取消明细
   * @param key 明细
   */

  const getDetailList = async (key: string) => {
    if (key === '发货明细') {
      dispatch(setIsTableLoadingAction(true))
      const res = await GET_SUPPLINER_ORDER_SHIP({ id: id })
      if (isResponseCodeSuccess(res.code)) {
        dispatch(setIsTableLoadingAction(false))
        dispatch(setDeliveryListAction(res.data))
        getOrderLogisticsInfo(res.data)
      }
    } else if (key === '退货明细') {
      dispatch(setIsTableLoadingAction(true))
      const res = await GET_SUPPLINER_ORDER_RETURN({ id: id })
      if (isResponseCodeSuccess(res.code)) {
        dispatch(setIsTableLoadingAction(false))
        dispatch(setReturnDetailListAction(res.data))
      }
    } else if (key === '取消明细') {
      dispatch(setIsTableLoadingAction(true))
      const res = await GET_SUPPLINER_ORDER_CANCEL({ id: id })
      if (isResponseCodeSuccess(res.code)) {
        dispatch(setIsTableLoadingAction(false))
        dispatch(setCancelDetailListAction(res.data))
      }
    }
  }

  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  const handleDownLoadTableCheck = (selectedRowKeys: any) => {
    dispatch(setDownLoadSelectedRowKeysAction(selectedRowKeys))
  }
  /**
   * 判断发货进度
   * @param record
   * @returns
   */
  const judgeDeliveryProgress = (converted: any) => {
    if (converted.waitQty > 0) return '待发货' // 未发货（待发数量>0）
    if (converted.waitQty === 0) return '已完成' // 全部发货（待发数量=0）
  }
  const getOrderCount = async () => {
    const res = await GET_SUPPLIER_COUNT({
      supplierOrderId: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(
        setCurrentRadioDictAction({
          商品明细: {
            key: 'productDetail',
            value: '商品明细',
            keyName: '商品明细',
          },
          发货明细: {
            key: 'deliveryDetail',
            value: `发货明细(${res?.data?.invoiceCount ?? 0})`,
            // value: `发货明细`,
            keyName: '发货明细',
          },
          退货明细: {
            key: 'returnDetail',
            value: `退货明细(${res?.data?.returnOrderCount ?? 0})`,
            // value: `退货明细`,
            keyName: '退货明细',
          },
          取消明细: {
            key: 'cancelDetail',
            value: `取消明细(${res?.data.cancellationOrderCount ?? 0})`,
            // value: `取消明细`,
            keyName: '取消明细',
          },
        }),
      )
    }
  }
  const getDetailInfo = async () => {
    dispatch(setLoadingAction(true))
    const res = await GET_SUPPLINER_ORDER_DETAIL({
      id: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 将嵌套的 directedSignVoucher 扁平化为页面可用字段
      const directedSignVoucher = (resData as any).directedSignVoucher
      const detailData = {
        ...resData,
        signVoucherState:
          directedSignVoucher?.signVoucherState ?? resData.signVoucherState,
        signVoucherRejectReason:
          directedSignVoucher?.signVoucherRejectReason ??
          resData.signVoucherRejectReason,
        signVoucherTime:
          directedSignVoucher?.signVoucherTime ?? resData.signVoucherTime,
        signVoucherFiles:
          directedSignVoucher?.signVoucherFiles ?? resData.signVoucherFiles ?? [],
      }
      dispatch(setDetailInfoAction(detailData))
      const detailedProductDTOList: any = resData.detailedProductDTOList.map(
        (item: any) => ({
          ...item,
          progress: judgeDeliveryProgress({
            ...item,
          }),
        }),
      )
      const customerOrderCodeList = resData.customerOrderCode
        ?.split(',')
        .map((code) => ({ customerOrderCode: code.trim() }))
      dispatch(setCustomerOrderCodeListAction(customerOrderCodeList))
      dispatch(setProductListAction(detailedProductDTOList))
      setTimeout(() => {
        getOrderCount()
      }, 200)
    } else {
      message.warning(res.msg)
    }
    dispatch(setLoadingAction(false))
  }
  // 订单状态如果不是待履约或履约中不能发货
  const handleDeliveryClick = async () => {
    const res = await GET_SUPPLINER_ORDER_DETAIL({
      id: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      if (res.data.orderState === '5' || res.data.orderState === '7') {
        message.error('订单处于修改审核中，请联系相关采购处理')
        return
      }
    }

    if (detailInfo?.scpShipStatusName === '已完成') {
      message.error('订单已完成,无需发货')
      return
    }

    const scpShipStatus = detailInfo.scpShipStatus
    if (selectedRows.length < 1) {
      message.error('请先选中货物')
      return
    }
    if (selectedRows.length > MAX_SUPPLIER_DELIVERY_COUNT) {
      message.warning(
        `您好，您只能勾选${MAX_SUPPLIER_DELIVERY_COUNT}行物料进行操作`,
      )
      return
    }
    if (
      selectedRows.some((item) => item.warehouse !== selectedRows[0].warehouse)
    ) {
      message.error('请选择同一批收货仓库的物料进行发货')
      return
    }
    if (scpShipStatus === 'WAIT') {
      history.push({
        pathname: '/srm/addsupplierdeliveryorder',
        state: {
          ...detailInfo,
          selectedProductList: selectedRows,
        },
      })
    }
  }

  // 商品明细导出发货单
  const exportSelectOrderDetail = async () => {
    if (selectedRows.length < 1 && customerOrderCodeList.length <= 1) {
      message.error('请先选中货物')
      return
    }
    if (customerOrderCodeList.length > 1 && detailInfo.directShipment) {
      dispatch(setDownLoadModalAciton(true))
    } else {
      exportNote(false)
    }
  }

  // 导出配货单
  const exportNote = async (isMultiple: boolean) => {
    const unshipped = isMultiple
      ? productList.filter(
          (item: { waitQty: number; shipQty: number }) =>
            (item.waitQty > 0 && item.shipQty === 0) ||
            (item.waitQty > 0 && item.shipQty > 0),
        )
      : selectedRows
    const params = {
      directShipment: detailInfo.directShipment,
      orderId: id,
      customerOrderCodes: isMultiple
        ? downLoadSelectedRowKeys.join(',')
        : detailInfo.customerOrderCode,
      productCodeList: unshipped.map((item) => item.productCode),
      ids: unshipped.map((item) => item.id),
    }
    // 调用导出函数
    await EXPORT_SELECT_ORDER_DETAIL(params)
  }

  // 商品明细-根据进度筛选
  const onProgressChange = (value: any) => {
    dispatch(setProgressValueAction(value))
    const filterRes = value
      ? detailInfo?.productList.filter((item: any) => item.progress === value)
      : detailInfo?.productList
    dispatch(setProductListAction(filterRes))
  }

  useEffect(() => {
    if (id) {
      getDetailInfo()
      getOrderStory()
    }
    getExpressSelectData()
    // 在订单详情页面时，点击消息中心跳转，订单id发生变化重新获取数据
    // eslint-disable-next-line
  }, [id])

  // 待办跳转时自动切换到取消明细tab
  useEffect(() => {
    if (tab === 'cancel') {
      handleCheckedChange('取消明细')
    }
    // eslint-disable-next-line
  }, [tab])

  useEffect(() => {
    if (contractId) {
      completeToDo(contractId)
    }
    // eslint-disable-next-line
  }, [contractId])
  const completeToDo = async (todoId: string) => {
    await COMPLETE_TODO({ todoId })
  }
  // 确认订单
  const confirmOrder = async () => {
    const res = await CONFIRM_ORDER({ id: detailInfo.id })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      getDetailInfo()
      getOrderStory()
    }
  }
  //
  const changeExpress = (item: any) => {
    if (
      item.logisticsCode.split(',').length > 1 ||
      item.trackNum.split(',').length > 1
    ) {
      message.warning('存在多个物流信息，不支持修改')
      return
    }
    formModal.setFieldsValue({
      expressCompany: item.logisticsCode,
      expressNo: item.trackNum,
    })
    dispatch(setExpressIdAction(item.id))
    dispatch(setIsChangeDeliveryInfoModalVisibleAction(true))
  }

  async function getExpressSelectData() {
    const res = await GET_OMS_EXPRESSCOMPANY_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setExpressSelectListAction(res.data))
    } else {
      message.warning('物流公司列表请求失败')
    }
  }
  const handleDeliveryInfoSave = async () => {
    const formValues = await formModal.validateFields()
    dispatch(setSubmitBtnLoadingAction(true))
    const expressName = getItemFromItemListByProperty(
      expressSelectList,
      'expressCode',
      formValues.expressCompany,
    )?.expressCompany
    const data = {
      id: expressId,
      logisticsCompany: expressName,
      logisticsCode: formValues.expressCompany,
      trackNum: formValues.expressNo,
    }
    const res = await CHANGE_EXPRESSCOMPANY({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      handleChangeDeliveryInfoCancel()
      getDetailList('发货明细')
      dispatch(setSubmitBtnLoadingAction(false))
    }
  }

  const handleChangeDeliveryInfoCancel = () => {
    dispatch(setIsChangeDeliveryInfoModalVisibleAction(false))
  }

  const onExpressSearch = (val: string) => {
    dispatch(setExpressSearchValueAction(val))
  }

  const onExpressSelect = () => {
    dispatch(setExpressSearchValueAction(''))
  }

  const confirmGoods = async (id: string) => {
    const res = await CONFIRM_GOODS({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      getDetailList('退货明细')
    }
  }

  const getOrderStory = async () => {
    const res = await ORDER_STORY({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      const resData: {
        [x in ProgressTimeKey]: number | null
      } = {
        ...res.data,
        completeStockTime: res.data.completeOrderTime,
      }
      const newProgressTime = progressTime.map((item) => ({
        ...item,
        time: resData[item.timeKey],
      }))
      dispatch(setProgressTimeAction(newProgressTime))
    }
  }
  const exportOrder = async () => {
    const res = await EXPORT_ALL_DETAIL({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }
  // 导出配货单直接下载到本地
  const exportSendOrder = async (orderid: string) => {
    EXPORT_ORDER_SHIP_DETAIL({ shippingOrderId: orderid })
  }
  const getCurrentProgress = () => {
    // <订单完成>步骤,有完成时间或订单状态为'已完成',就默认走到最后一步
    const done = progressTime.find((item) => {
      return item.timeKey === 'completeOrderTime'
    })
    if (done?.time || detailInfo?.scpShipStatusName === '已完成') {
      return 5
    } else {
      return progressTime.filter((item) => item.time).length
    }
  }

  // 获取物流轨迹信息
  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  const showPreviewModal = (url: string, watermarkOption?: WaterMarkOption) => {
    dispatch(setPreviewFileUrlAction(url))
    dispatch(setWaterMarkOptionAction(watermarkOption))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  const getOrderLogisticsInfo = async (data: any) => {
    // 获取当前所有发货单对应的物流信息
    const res: LogisticsInformation[][] = await Promise.all(
      data.map(async (item: any) => {
        if (item.trackNum) {
          const res = await GET_LOGISTICS_INFORMATION({
            expressCode: item.logisticsCode,
            expressNo: item.trackNum,
            id: item.id,
            phoneNumber: detailInfo.receiveMobile,
          })
          if (isResponseCodeSuccess(res.code)) {
            return res.data
          } else {
            return []
          }
        }
      }),
    )
    dispatch(setLogisticsInfoListAction(res))
  }

  // 拒绝接单按钮
  const rejectOrder = () => {
    dispatch(setRejectModalOpenAction(true))
  }

  // 确认拒绝接单
  const handleRejectOk = async () => {
    if (rejectReason !== '') {
      dispatch(setRejectLoadingAction(true))
      const res = await REFUSE_SUPPLIER_ORDER({
        orderId: id,
        refuseReason: rejectReason,
        refuseOperatorId: getUserId(),
      })
      if (isResponseCodeSuccess(res.code)) {
        dispatch(setRejectReasonAction(''))
        dispatch(setRejectModalOpenAction(false))
        dispatch(setRejectLoadingAction(false))
        getDetailInfo()
        getOrderStory()
      } else {
        dispatch(setRejectLoadingAction(false))
      }
    } else {
      dispatch(setShowTipAction(true))
    }
  }

  // 取消拒绝接单
  const handleRejectCancel = () => {
    dispatch(setShowTipAction(false))
    dispatch(setRejectReasonAction(''))
    dispatch(setRejectModalOpenAction(false))
  }

  // 修改拒绝接单理由
  const changeRejectReason = (val: string) => {
    dispatch(setShowTipAction(false))
    dispatch(setRejectReasonAction(val))
  }

  // 关闭导出弹窗
  const downLoadModalCancel = () => {
    dispatch(setDownLoadModalAciton(false))
  }

  const downLoadModalOk = () => {
    if (!downLoadSelectedRowKeys.length) {
      message.warning('请先选择订单号')
      return
    } else if (downLoadSelectedRowKeys.length >= 200) {
      message.warning('每次最多选择200条客户订单导出')
      return
    }
    exportNote(true)
    dispatch(setDownLoadModalAciton(false))
  }
  return {
    hooksState: state,
    handleCheckedChange,
    handleDeliveryClick,
    handleTableChangeCheck,
    onProgressChange,
    confirmOrder,
    changeExpress,
    submitBtnLoading,
    handleDeliveryInfoSave,
    handleChangeDeliveryInfoCancel,
    formModal,
    onExpressSearch,
    onExpressSelect,
    confirmGoods,
    exportOrder,
    exportSendOrder,
    getCurrentProgress,
    getDetailInfo,
    exportSelectOrderDetail,
    logisticsInfoList,
    showPreviewModal,
    cancelPreviewModal,
    rejectOrder,
    handleRejectOk,
    handleRejectCancel,
    changeRejectReason,
    downLoadModalCancel,
    downLoadModalOk,
    handleDownLoadTableCheck,
  }
}
